'use client';
import { createContext } from 'react';

export type SurfaceType = 'neutral' | 'inverted';

export const SurfaceContext = createContext<{
  value: SurfaceType;
  setValue: (value: SurfaceType) => void;
}>({
  value: 'neutral',
  setValue: () => {},
});
